import React from 'react';
import { SegmentedControl, Box, SpaceBetween, Badge } from '@cloudscape-design/components';

/**
 * The demo's headline control: how the sellers' WAF treats agent traffic.
 *
 *   Monetized  — WAF charges the agent per request: it's asked to pay, pays, and is
 *                served the content. Same door, now it earns revenue.
 *   Blocked    — WAF blocks the agent outright: no content served, no revenue.
 *
 * The selection is sent to the agent (it changes the seller base the agent calls).
 * Locally both map to the in-process seller and we flip its posture; deployed, they
 * are two separate CloudFront distributions over the same origins.
 */
export default function EdgeToggle({ value, onChange, disabled, compact = false }) {
  const control = (
    <SegmentedControl
      selectedId={value}
      onChange={({ detail }) => onChange(detail.selectedId)}
      disabled={disabled}
      label="Seller WAF treats agents as"
      options={[
        { id: 'monetized', text: '💰 Monetized' },
        { id: 'blocked', text: '🚫 Blocked' },
      ]}
    />
  );
  // Compact: just the control (used inline in the one-row wallet header).
  if (compact) return control;

  return (
    <SpaceBetween size="xxs">
      <Box variant="awsui-key-label">Seller WAF treats agents as</Box>
      {control}
      <Box fontSize="body-s" color="text-body-secondary">
        {value === 'monetized' ? (
          <>
            <Badge color="green">monetize</Badge> WAF charges the agent per request — it pays and gets the content.
          </>
        ) : (
          <>
            <Badge color="red">block</Badge> WAF blocks the agent — no content served, and no revenue earned.
          </>
        )}
      </Box>
    </SpaceBetween>
  );
}
